module.exports = __webpack_public_path__ + "img/team3.5c697f81.jpg";